import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { createFromInvoice } from "../../../models/CreditNoteModel";
import { apiError } from "../../../helpers/ErrorHelper";
import { useNavigate } from "react-router-dom";

export default function CreateCreditNoteFromInvoiceModal({
  showModal,
  setShowModal,
  user_token,
  invoice_unique_id,
}) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [billDate, setBillDate] = useState(
    new Date().toISOString().slice(0, 10)
  );

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await createFromInvoice(user_token, invoice_unique_id, {
        credit_note_bill_date: billDate,
      });
      if (response?.status) {
        toast.success(response.message || "Credit note created");
        setShowModal(false);
        const id = response.data?.credit_note_unique_id;
        if (id) {
          navigate(`/credit-notes/${id}/edit`);
        }
      } else {
        toast.error(response?.message || "Could not create credit note");
      }
    } catch (error) {
      apiError(error);
    }
    setLoading(false);
  };

  return (
    <Modal show={showModal} onHide={() => setShowModal(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Create credit note from invoice</Modal.Title>
      </Modal.Header>
      <form onSubmit={onSubmit}>
        <Modal.Body>
          <p className="text-muted fs-13">
            Creates a new credit note linked to this invoice and copies line items
            and shipping. The invoice itself is not changed.
          </p>
          <label className="form-label">Credit note date</label>
          <input
            type="date"
            className="form-control"
            value={billDate}
            onChange={(e) => setBillDate(e.target.value)}
            required
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button type="submit" variant="primary" disabled={loading}>
            {loading ? "Creating…" : "Create credit note"}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
